import { Component, ViewContainerRef } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { MbOrderFacade } from '../../facades/mb-order.facade'
import { MbSpinnerService } from '../../../shared/services/mb-spinner.service'

@Component({
  selector: 'mb-checkout-payment',
  template: ''
})
export class MbCheckoutPaymentComponent {

  constructor (protected activatedRoute: ActivatedRoute,
               protected mbCheckoutService: MbOrderFacade,
               protected mbSpinnerService: MbSpinnerService,
               protected vcr: ViewContainerRef) {
    this.mbSpinnerService.launchMbSpinner(this.vcr)
    const { RETURNMAC, cartId, hostedCheckoutId } = this.activatedRoute.snapshot.queryParams
    if (RETURNMAC && hostedCheckoutId) {
      this.mbCheckoutService.placeOrderWithPayment(RETURNMAC, hostedCheckoutId)
    } else {
      this.mbCheckoutService.resetIngenicoPayment()
    }
  }
}
